export enum WebComponents {
  MainView = 'chl-mngmnt-main'
}